<template>
    <div class="resource-tags">
        <v-chip
            v-for="resource in displayResources"
            :key="resource.id"
            :color="getChipColor(resource)"
            :outlined="outlined"
            :small="small"
            :x-small="xSmall"
            class="mr-1 mb-1"
        >
            <v-icon 
                :left="!iconOnly" 
                :small="small || xSmall"
                :x-small="xSmall"
            >
                {{ getResourceIcon(resource) }}
            </v-icon>
            <span v-if="!iconOnly">{{ resource.name || resource.resource?.name }}</span>
        </v-chip>
        
        <v-chip
            v-if="hasMoreResources && !showAll"
            small
            outlined
            color="grey"
            @click="$emit('show-all')"
            class="mr-1 mb-1"
        >
            +{{ resources.length - maxDisplay }}
        </v-chip>
    </div>
</template>

<script>
export default {
    name: 'SysAmbienceResourceTags',
    
    props: {
        resources: {
            type: Array,
            default: () => []
        },
        maxDisplay: {
            type: Number,
            default: 4
        },
        showAll: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        },
        xSmall: {
            type: Boolean,
            default: false
        },
        outlined: {
            type: Boolean,
            default: true
        },
        iconOnly: {
            type: Boolean,
            default: false
        }
    },

    data: () => ({
        resourceIcons: {
            'wi-fi': 'mdi-wifi',
            'wifi': 'mdi-wifi',
            'projetor': 'mdi-projector',
            'ar-condicionado': 'mdi-snowflake',
            'ar condicionado': 'mdi-snowflake',
            'som': 'mdi-speaker',
            'audio': 'mdi-speaker',
            'quadro': 'mdi-drawing',
            'lousa': 'mdi-drawing',
            'tomadas': 'mdi-power-plug',
            'tomada': 'mdi-power-plug',
            'acessibilidade': 'mdi-wheelchair-accessibility',
            'pcd': 'mdi-wheelchair-accessibility',
            'lab química': 'mdi-flask',
            'lab quimica': 'mdi-flask',
            'laboratório': 'mdi-flask',
            'laboratorio': 'mdi-flask',
            'computador': 'mdi-desktop-classic',
            'tv': 'mdi-television',
            'televisão': 'mdi-television',
            'televisao': 'mdi-television',
            'impressora': 'mdi-printer',
            'microfone': 'mdi-microphone',
            'camera': 'mdi-camera',
            'câmera': 'mdi-camera',
            'ventilador': 'mdi-fan',
            'ar': 'mdi-snowflake',
        },
        resourceColors: {
            'wi-fi': 'blue',
            'wifi': 'blue',
            'projetor': 'purple',
            'ar-condicionado': 'cyan',
            'ar condicionado': 'cyan',
            'acessibilidade': 'green',
            'pcd': 'green',
            'lab química': 'orange',
            'lab quimica': 'orange',
        }
    }),

    computed: {
        displayResources() {
            if (this.showAll) {
                return this.resources
            }
            return this.resources.slice(0, this.maxDisplay)
        },
        
        hasMoreResources() {
            return this.resources.length > this.maxDisplay
        }
    },

    methods: {
        getResourceIcon(resource) {
            const name = (resource.name || resource.resource?.name || '').toLowerCase()
            
            for (const [key, icon] of Object.entries(this.resourceIcons)) {
                if (name.includes(key)) {
                    return icon
                }
            }
            
            return 'mdi-checkbox-marked-circle-outline'
        },
        
        getChipColor(resource) {
            const name = (resource.name || resource.resource?.name || '').toLowerCase()
            
            for (const [key, color] of Object.entries(this.resourceColors)) {
                if (name.includes(key)) {
                    return color
                }
            }
            
            return 'grey'
        }
    }
}
</script>

<style scoped>
.resource-tags {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}
</style>
